var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrozen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 4l2 1l2 -1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 2v6.5l3 1.72"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.928 6.268l.134 2.232l1.866 1.232"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.66 7l-5.629 3.25l.01 3.458"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.928 14.268l-1.866 1.232l-.134 2.232"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.66 17l-5.629 -3.25l-2.99 1.738"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14 20l-2 -1l-2 1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12 22v-6.5l-3 -1.72"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M6.072 17.732l-.134 -2.232l-1.866 -1.232"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M3.34 17l5.629 -3.25l-.01 -3.458"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M4.072 9.732l1.866 -1.232l.134 -2.232"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M3.34 7l5.629 3.25l2.99 -1.738"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrozen);
export default __webpack_public_path__ + "static/media/frozen.c5f20e3aac11c3ba245171e6d57af495.svg";
export { ForwardRef as ReactComponent };